export * from './full-layout.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/containers/full-layout/index.ts